import { JsonObject, JsonProperty } from "ta-json";

import type { MapStringTo } from "../../base-types";
import Guard from "../../guard";

@JsonObject()
export class UploadAction {
    constructor(name: string, parameters?: MapStringTo<unknown>) {
        Guard.stringNotNullOrEmpty(name);

        this.name = name;
        this.parameters = parameters;
    }

    @JsonProperty("name")
    name: string;

    @JsonProperty("parameters")
    parameters?: MapStringTo<unknown>;
}
